import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { normalizeInstagramHandle, isValidInstagramHandle } from "@lib/utils";
import { t } from "../../i18n";

export function OnboardingTargetPage() {
  const navigate = useNavigate();
  const [handle, setHandle] = useState("");
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const normalized = normalizeInstagramHandle(handle);
    if (!normalized || !isValidInstagramHandle(normalized)) {
      setError(t("validationLengthOrChars"));
      return;
    }

    setError(null);
    navigate(`/onboarding/processing?handle=${encodeURIComponent(normalized)}`);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg, #fdf2f2 0%, #ffffff 100%)",
        padding: "24px",
      }}
    >
      <div style={{ maxWidth: "400px", width: "100%", textAlign: "center" }}>
        <h1
          style={{
            fontSize: "1.5rem",
            fontWeight: 800,
            color: "#171717",
            marginBottom: "8px",
          }}
        >
          {t("onboardingTargetTitle")}
        </h1>
        <p
          style={{
            color: "#737373",
            marginBottom: "24px",
            fontSize: "0.9375rem",
            lineHeight: 1.5,
          }}
        >
          {t("addTargetSubtitle")}
        </p>

        <form onSubmit={handleSubmit}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              background: "white",
              border: `1.5px solid ${error ? "#ef4444" : "rgba(15, 23, 42, 0.1)"}`,
              borderRadius: "16px",
              padding: "4px",
              paddingLeft: "16px",
              gap: "8px",
            }}
          >
            <span style={{ color: "#a3a3a3", fontWeight: 600, fontSize: "1rem" }}>@</span>
            <input
              value={handle}
              onChange={(e) => {
                setHandle(e.target.value.replace(/^@/, ""));
                setError(null);
              }}
              placeholder="username"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              autoFocus
              style={{
                flex: 1,
                border: "none",
                outline: "none",
                fontSize: "1rem",
                fontWeight: 600,
                color: "#171717",
                background: "transparent",
                padding: "12px 0",
              }}
            />
            <button
              type="submit"
              style={{
                background: "var(--pink-primary, #ff6b8a)",
                color: "white",
                border: "none",
                padding: "12px 20px",
                borderRadius: "12px",
                fontWeight: 700,
                fontSize: "0.9375rem",
                cursor: "pointer",
                whiteSpace: "nowrap",
              }}
            >
              {t("landingHeroCta")}
            </button>
          </div>
          {error && (
            <p style={{ color: "#ef4444", fontSize: "0.8125rem", marginTop: "8px", textAlign: "left" }}>
              {error}
            </p>
          )}
        </form>
      </div>
    </div>
  );
}
